import { render, staticRenderFns } from "./systemFeedback.vue?vue&type=template&id=4790b179&scoped=true"
import script from "./systemFeedback.vue?vue&type=script&lang=js"
export * from "./systemFeedback.vue?vue&type=script&lang=js"
import style0 from "./systemFeedback.vue?vue&type=style&index=0&id=4790b179&prod&scoped=true&lang=scss"
import style1 from "./systemFeedback.vue?vue&type=style&index=1&id=4790b179&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4790b179",
  null
  
)

export default component.exports